<template>
    <v-row dense>
        <v-col
                dense
                cols="12"
                class="mb-0">
            <v-date-picker
                    v-if="field.datetime.type === 'date'"
                    v-model="value"
                    dense
                    :color="(!!error) ? 'red' : 'primary'"
                    outlined />
            <v-time-picker
                    v-if="field.datetime.type === 'time'"
                    v-model="value"
                    dense
                    :color="(!!error) ? 'red' : 'primary'"
                    format="ampm"
                    outlined />
            <v-messages
                    v-if="errorState"
                    class="mt-2"
                    color="error"
                    :value="[error]" />
        </v-col>
        <v-col
                cols="12"
                dense>
            <v-btn
                    v-if="!!value"
                    small
                    class="warning mt-0"
                    @click="value = null">
                Clear value
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
    import Value from "../../../../../models/value.model";
    import moment from "moment";
    import Field from "@/models/field.model";

    export default {
        name: "FieldDatetimeComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                value: null,
                error: null,
            }
        },
        computed: {
            errorState() {
                return !!this.error;
            }
        },
        watch: {
            value() {
                this.getValue().then((value) => {
                    this.$emit('updateValue', value);
                })
            }
        },
        mounted() {
            this.value = this.field.value.value;
        },
        methods: {
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                const value = new Value({
                    value: this.value,
                    isValid: true
                });
                if (!this.field.is_optional && value.isEmpty) {
                    this.error = 'Mandatory field';
                    value.isValid = false;
                }

                if (!value.isEmpty) {
                    if (this.isValid() === true) {
                        value.isValid = true;
                        this.error = null;
                    } else {
                        this.error = this.isValid();
                    }
                }

                if (this.error) {
                    value.isValid = false;
                    value.error = this.error;
                }

                return value;
            },
            validateDate(newValue) {
                return moment(newValue, 'YYYY-MM-DD').isValid();
            },
            validateTime(newValue) {
                return moment(newValue, 'HH:mm').isValid();
            },
            isValid() {
                switch (this.field.datetime.type) {
                case 'date':
                    return this.validateDate(this.value) || 'Invalid date format';
                case 'time':
                    return this.validateTime(this.value) || 'Invalid time format';
                default:
                    return 'Invalid input'
                }
            },
        }
    }
</script>

<style scoped>
	.maz-input__input {
		height: 56px !important;
	}
</style>